<template>
  <div v-if="!isLoading">
    <InputSearch v-model="searchInput" />

    <div
      class="table-wrapper"
      v-if="searchResult.length"
    >
      <table class="table">
        <thead>
          <tr>
            <th width="50%">Applications</th>
            <th width="50%">Area</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in searchResult"
            :key="index"
          >
            <td>{{ item.application }}</td>
            <td>{{ item.area }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <EmptyState
      v-else
      :query="searchInput"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'AccessManagementApplications',

  inject: ['searchItems'],

  data () {
    return {
      items: [],
      searchInput: ''
    }
  },

  computed: {
    ...mapState('global', ['isLoading']),

    searchResult () {
      const query = this.searchInput.toLowerCase().trim()
      const items = this.items
      const result = this.searchItems(items, query) || []

      return result
    }
  },

  methods: {
    ...mapMutations('global', ['SET_IS_LOADING']),

    parseData (data) {
      const items = []

      data.forEach((item) => {
        const entry = {
          application: item.gsx$systemwebsitetoolsw.$t,
          area: item.gsx$area.$t
        }

        items.push(entry)
      })

      this.items = items
    },

    fetchData () {
      const api = `https://sheets.googleapis.com/v4/spreadsheets/1Fjhb4bzcPtyHWkAchFeFb14hBd71g_vOQG1wCz9uIT4`
      const url = `${api}/values/Sheet1?alt=json`

      this.SET_IS_LOADING(true)

      axios
        .get(url)
        .then((response) => {
          this.parseData(response.data.feed.entry)
        })
        .catch((error) => {
          throw error
        })
        .then(() => {
          this.SET_IS_LOADING(false)
        })
    }
  },

  mounted () {
    this.fetchData()
  }
}
</script>
